<template>
    <div>
        <div class="form-group">
            <input
                id="add_challange"
                name="add_challange"
                type="checkbox"
                value="true"
                v-model="challange"
                @change="hideCat"
            />
            <label>Denna tråden är en utmaning.</label>
        </div>

        <div id="challange-options" v-bind:class="{ 'add-challange': challange }">
            <div class="form-group">
                <label>Fråga</label>
                <span class="description"
                    >Vad ska deltagarna gör, formulera som en fråga, t ex "Har du gått 10 000 steg
                    idag?"</span
                >
                <input
                    type="text"
                    class="form-control"
                    v-model="title"
                    name="challange_title"
                    id="challange_title"
                />
            </div>
            <div class="form-group">
                <label>Beskrivning</label>
                <span class="description"
                    >Ge en mer detaljerad förklaring till uppgiften som deltagarna ska utföra.</span
                >
                <textarea
                    class="form-control"
                    v-model="decription"
                    name="challange_description"
                    id="challange_description"
                ></textarea>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <label>Intervall</label>
                        <span class="description">Hur ofta ska uppgiften utföras</span>
                        <input
                            type="number"
                            class="form-control"
                            name="amount"
                            id="amount"
                            v-model="amount"
                        />
                    </div>
                    <div class="col-xs-12 col-md-6 days">
                        <label></label>
                        <span class="description">dagar/veckor</span>
                        <select name="days_weeks" class="form-control" id="days_weeks" v-model="days">
                            <option selected>dagar</option>
                            <option>veckor</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>Startdatum</label>
                <span class="description">Första dagen för utmaningen</span>
                <input autocomplete="off" class="form-control" name="date" id="date" v-model="date" />
            </div>
        </div>
        <div v-if="challange" class="divider"></div>
    </div>
</template>

<script>
import axios from 'axios';
import datepicker from 'js-datepicker';

export default {
    data() {
        return {
            challange: !old_add_challange.length ? false : old_add_challange,
            title: old_challange_title,
            decription: old_challange_description,
            days: old_days_weeks,
            amount: old_amount,
            date: old_date
        };
    },

    mounted() {
        if (old_add_challange.length) {
            document.getElementById('forum_category').parentElement.classList.add('hide-cat');
        } else {
            document.getElementById('forum_category').parentElement.classList.remove('hide-cat');
        }

        const picker = datepicker('#date', {
            startDay: 1,
            customDays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
            customMonths: [
                'Januari',
                'Februari',
                'Mars',
                'April',
                'Maj',
                'Juni',
                'Juli',
                'Augusti',
                'September',
                'Oktober',
                'November',
                'December'
            ],
            onSelect: (instance, date) => {},
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString('sv-SE');
                input.value = value; // => '1/1/2099'
            }
        });
    },

    methods: {
        hideCat: function () {
            document.getElementById('forum_category').parentElement.classList.toggle('hide-cat');
        }
    }
};
</script>
